import GraphQLPageLayout from './GraphQLPageLayout';

export default GraphQLPageLayout;
